import React from 'react';
import TableBadge from '@spark/ui-components/components/TanStackTable/components/TableBadge';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import Tooltip from '@spark/ui-components/components/Tooltip';

const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  const numberValue = Number(value);
  if (Number.isNaN(numberValue)) return String(value);
  return numberValue.toLocaleString('pt-BR', { maximumFractionDigits: 2 });
};

const SituacaoBadge = ({ value }) => {
  const val = (value || '').toString().toUpperCase();
  const color = val === 'ATIVO' ? 'success' : val === 'INATIVO' ? 'neutral' : 'warning';
  const label = val || '-';
  return <TableBadge color={color} label={label} />;
};

const toStr = (value) => (value === null || value === undefined ? '' : String(value));

export const getVeiculosColumns = () => [
  {
    id: 'frota',
    header: 'Frota',
    accessorKey: 'frota',
    size: 160,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={20} />,
  },
  {
    id: 'placa',
    header: 'Placa',
    accessorKey: 'placa',
    size: 130,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={10} />,
  },
  {
    id: 'renavam',
    header: 'Renavam',
    accessorKey: 'renavam',
    size: 160,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={14} />,
  },
  {
    id: 'uf',
    header: 'UF',
    accessorKey: 'uf',
    size: 80,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={toStr(getValue()).toUpperCase()} maxLength={2} />,
  },
  {
    id: 'descricao',
    header: 'Descricao',
    accessorKey: 'descricao',
    size: 220,
    enableSorting: true,
    cell: ({ getValue }) => {
      const val = toStr(getValue());
      return (
        <Tooltip dir="top" text={val}>
          <div style={{ cursor: 'pointer' }}>
            <TruncatedText value={val} maxLength={28} />
          </div>
        </Tooltip>
      );
    },
  },
  {
    id: 'nomeTipoModeloVeicular',
    header: 'Tipo de Modelo',
    accessorKey: 'nomeTipoModeloVeicular',
    size: 180,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={20} />,
  },
  {
    id: 'unidadeCapacidade',
    header: 'Unid. Capacidade',
    accessorKey: 'unidadeCapacidade',
    size: 130,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={10} />,
  },
  {
    id: 'capacidadeModelo',
    header: 'Capacidade',
    accessorKey: 'capacidadeModelo',
    size: 120,
    enableSorting: true,
    cell: ({ getValue }) => <span>{formatNumber(getValue())}</span>,
  },
  {
    id: 'numeroEixos',
    header: 'Eixos',
    accessorKey: 'numeroEixos',
    size: 90,
    enableSorting: true,
    cell: ({ getValue }) => <span>{formatNumber(getValue())}</span>,
  },
  {
    id: 'ocupacaoCubicaPallets',
    header: 'Ocupacao Cubica (pallets)',
    accessorKey: 'ocupacaoCubicaPallets',
    size: 170,
    enableSorting: true,
    cell: ({ getValue }) => <span>{formatNumber(getValue())}</span>,
  },
  {
    id: 'toleranciaMinimaCarregamento',
    header: 'Tol. Min. Carreg.',
    accessorKey: 'toleranciaMinimaCarregamento',
    size: 160,
    enableSorting: true,
    cell: ({ getValue }) => <span>{formatNumber(getValue())}</span>,
  },
  {
    id: 'codigoIntegracao',
    header: 'Cod. Integracao',
    accessorKey: 'codigoIntegracao',
    size: 160,
    enableSorting: true,
    cell: ({ getValue }) => {
      const val = toStr(getValue());
      return (
        <Tooltip dir="top" text={val}>
          <div style={{ cursor: 'pointer' }}>
            <TruncatedText value={val} maxLength={18} />
          </div>
        </Tooltip>
      );
    },
  },
  {
    id: 'situacao',
    header: 'Situacao',
    accessorKey: 'situacao',
    size: 110,
    enableSorting: true,
    cell: ({ getValue }) => {
      const value = getValue();
      const label = value === 1 ? 'Ativo' : 'Inativo';
      return <SituacaoBadge value={label} />;
    },
  },
];
